"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentPhotoIdResponseToJSON = exports.AttachmentPhotoIdResponseFromJSONTyped = exports.AttachmentPhotoIdResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentPhotoIdResponseFromJSON(json) {
    return AttachmentPhotoIdResponseFromJSONTyped(json, false);
}
exports.AttachmentPhotoIdResponseFromJSON = AttachmentPhotoIdResponseFromJSON;
function AttachmentPhotoIdResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attachment': _1.AttachmentPhotoIdModelFromJSON(json['attachment']),
        'hasBackSide': !runtime_1.exists(json, 'hasBackSide') ? undefined : json['hasBackSide'],
        'fields': !runtime_1.exists(json, 'fields') ? undefined : (json['fields'].map(_1.FieldModelFromJSON)),
        'required': _1.AttachmentPhotoIdResponseRequiredFromJSON(json['required']),
        'documentReviewNotes': !runtime_1.exists(json, 'documentReviewNotes') ? undefined : json['documentReviewNotes'],
    };
}
exports.AttachmentPhotoIdResponseFromJSONTyped = AttachmentPhotoIdResponseFromJSONTyped;
function AttachmentPhotoIdResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attachment': _1.AttachmentPhotoIdModelToJSON(value.attachment),
        'hasBackSide': value.hasBackSide,
        'fields': value.fields === undefined ? undefined : (value.fields.map(_1.FieldModelToJSON)),
        'required': _1.AttachmentPhotoIdResponseRequiredToJSON(value.required),
        'documentReviewNotes': value.documentReviewNotes,
    };
}
exports.AttachmentPhotoIdResponseToJSON = AttachmentPhotoIdResponseToJSON;
//# sourceMappingURL=AttachmentPhotoIdResponse.js.map